import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import { ConsumerCategory } from '@/features/consumerCategories/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const consumerCategoriesApi = createApi({
  reducerPath: 'consumerCategoriesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/consumer-categories`,
  }),
  tagTypes: ['ConsumerCategory'],
  endpoints: builder => ({
    getConsumerCategories: builder.query<ConsumerCategory[], void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: () => ['ConsumerCategory'],
    }),
    getConsumerCategoriesI: builder.infiniteQuery<
      ConsumerCategory[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['ConsumerCategory'],
    }),
    getConsumerCategoriesQueryI: builder.infiniteQuery<
      ConsumerCategory[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['ConsumerCategory'],
    }),
  }),
});

export const { useGetConsumerCategoriesQuery } = consumerCategoriesApi;

export const useGetConsumerCategoriesInfiniteQuery =
  normalizeInfiniteQueryData<ConsumerCategory>(
    consumerCategoriesApi.useGetConsumerCategoriesIInfiniteQuery,
  );

export const useGetConsumerCategoriesQueryIInfiniteQuery =
  normalizeInfiniteQueryData<ConsumerCategory>(
    consumerCategoriesApi.useGetConsumerCategoriesQueryIInfiniteQuery,
  );
